<div class="viz-loader-backdrop">
  <div class="viz-loader-container">
    <mode-loader></mode-loader>
    <div *ngIf="showLongLoadTimeMsg" class="long-render-msg" data-test="viz-loader-msg">
      It might take longer than usual to load because it contains a large number of visual elements.
    </div>
  </div>
</div>
